<template>
  <div class="page--data_rotation_setup">
    <div class="inner-wrap">
      <div class="head">
        <div class="item key"></div>
        <div class="item period">{{ $t("field.data_rotation_setup.period_month") }}</div>
        <div class="item align-right enabled">{{ $t("field.data_rotation_setup.is_enabled") }}</div>
      </div>
      <div class="content-body">
        <div class="table" v-for="data in rotation_datas" :key="data.table_key">
          <div class="field key">
            {{ $t(`data_rotation_setup.item.${data.table_key}`) }}
          </div>
          <div class="field period">
            <input v-model="data.period_month" type="number">
          </div>
          <div class="field align-right enabled">
            <input type="checkbox" v-model="data.is_enabled">
          </div>
        </div>
      </div>
      <div class="action-btn">
        <el-button type="primary" @click="confirm">{{ $t("button.confirm") }}</el-button>
      </div>
      <Datatable unikey="sys_logs" :table-data="logs" :fields="[
          { key: 'id', width: 100 },
          { key: 'log_message' },
          { key: 'created_dt', width: 200 },
        ]"
        :setting="{pagination,sort}"
        @changePage="changePage($event)"
      />
    </div>
  </div>
</template>

<script>
import Datatable from "@/components/widgets/Datatable/Datatable";

export default {
  components: {
    Datatable
  },
  async beforeMount() {
    this.fetchData();
    this.keys.map(k=>{
      this.input[k] = {};
    });
    this.rotation_datas = (await this.$axios("data_rotations")).data;
  },
  methods: {
    confirm() {
      this.$axios.post("data_rotations", this.rotation_datas).then(res=>{
        this.$notify({
          // title: 'Success',
          message: this.$t("message.data_has_updated"),
          type: 'success'
        });
      }).catch(err=>{

      });
    },
    fetchData() {
      this.$axios.get(`sys_logs`, {
        params: {
          size: this.pagination.perPage,
          page: this.pagination.current > 0 ? this.pagination.current - 1 : 0,
          sort_by: "id",
          order: "desc",
          task: "schedule",
          // active: this.trashMode == 0 ? 1 : 0
        }
      }).then(res=>{
        let data = res.data.response.dataset;
          this.logs = data.content;
          this.pagination.max = data.totalPages;
          if(this.pagination.current > this.pagination.max && this.pagination.max > 0) {
            this.pagination.current = this.pagination.max;
            this.fetchData();
          }
          this.pagination.item = data.totalElements;
          // this.$refs.table.updateData();
      });
    },
    changePage(page) {
      this.pagination.current = page;
      this.fetchData();
    }
  },
  data() {
    return {
      keys: ["cp_request","cp_meter_value","cp_session"],
      input: {},
      rotation_datas: [],
      logs: [],

      pagination: {
        perPage: 5,
        total: 0,
        current: 1,
        item: 0,
        max: 0
      },
      sort: {
        field: "",
        order: ""
      },
    }
  }
}
</script>

<style lang="scss">
.page--data_rotation_setup{
  display: flex;
  justify-content: center;
  // margin-top: 10%;
  .inner-wrap{
    width: 100%;
    .head{
      display: flex;
      margin-bottom: 10px;
      .item{
        font-size: 14px;
        &.key{
          width: 150px;
        }
        &.period{
          width: 70%;
        }
        &.enabled{
          width: 15%;
        }
      }
    }
    .content-body{
      .table{
        display: flex;
        margin-bottom: 10px;
        .field{
          // width: 33.33%;
          font-size: 14px;
          input[type="number"]{
            height: 30px;
            width: 100%;
          }
          input[type="checkbox"]{
            height: 20px;
            width: 15px;
          }

          &.key{
            width: 150px;
          }
          &.period{
            width: 70%;
          }
          &.enabled{
            width: 15%;
          }
        }
      }
    }
    .action-btn{
      margin: 10px 0;
      text-align: right;
    }
  }
  .align-right{
    text-align: right;
  }
}
</style>